import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "./components/HeroSection";
import OverviewSection from "./components/OverviewSection";
import PlotSection from "./components/PlotSection";
import ReviewSection from "./components/ReviewSection";
import ExplainerSection from "./components/ExplainerSection";
import CharacterSection from "./components/CharacterSection";
import HighlightSection from "./components/HighlightSection";
import ImpressionSection from "./components/ImpressionSection";
import RelatedSection from "./components/RelatedSection";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <SiteNav />
      <main>
        <HeroSection />
        <OverviewSection />
        <PlotSection />
        <ReviewSection />
        <ExplainerSection />
        <CharacterSection />
        <HighlightSection />
        <ImpressionSection />
        <RelatedSection />
        <FaqSection />
        <CtaBand />
      </main>
      <SiteFooter />
    </div>
  );
}